

import React from "react";
import {
  PatientRegContext,
  NextOfKinContext,
  VisitDetails,
  ReferralDetails,
  FinancialFormContext,
  DataPayloadContext,
  QueueManagementContext,
  VisitFormContext,
  RoleContext
} from "./";
const AssembleReg = (props) => {

  let [patientData, setPatientData] = React.useState({
    identification: [{}],
    names: [{}],
    details: {},
    communication: {},
    contact: {},
    address: [],
  });
  let [nextOfKin, setNextOfKin] = React.useState({
    identification: [{}],
    names: [{}],
    details: {},
    contact: {},
    address: [],
    addformdetails: [],
    index: null,
  });

  let [visitData, setVisitDetails] = React.useState({
    encounter: {},
    practitioner: {},
    device: {},
    helthcare: {},
    accompained: {},
  });
  let [referralData, setReferralDetails] = React.useState({
    letter: {},
    from: {},
    to: {},
    details: {},
    note: {},
  });

  let [financialData, setFinancialData] = React.useState({
    payer: {},
    validity: {},
    membership: {},
    eligibility: {},
    financial: {},
    applicable: {},
    savedata: [],
    index: null,
  });

  let [additnaldata, setadditnaldata] = React.useState({
    additnaldata: {},
    birthdetails: {},
  });

  const [allData, setAllData] = React.useState([]);
  const [previous, setPrevious] = React.useState([]);
  const [attend, setAttend] = React.useState([]);
  const [next, setNext] = React.useState([]);
  const [TabData, setTabData] = React.useState([]);
  const [selectedQueue, setSelectedQueue] = React.useState({});
  const [data, setQueueData] = React.useState([]);
  const [onHoldData, setOnHoldData] = React.useState([]);
  const [previousData, setPreviousData] = React.useState([]);
  const [displayData, setDisplayData] = React.useState([]);
  const [displayPreviousData, setDisplayPreviousData] = React.useState([]);
  const [previousQueue ,setpreviousQueue] = React.useState("");
  const [ActiveTab ,setActiveTab] = React.useState(0);
  const [HeaderTabActive ,setHeaderTabActive] = React.useState(0);
  const [loader , setloader] =  React.useState(false);

  let [visitform, setvisitform] = React.useState({
    encounterInfo: {},
    bookingdetails: {},
    pactitioner: {},
    deviceDetails: {},
    reasonDetails: {},
    setvisitform: () => null,
  });

  let [role, setData] = React.useState({
    role: null,
    setData: () => null,
  });
  return (
    <PatientRegContext.Provider value={{ ...patientData, setPatientData }}>
      <NextOfKinContext.Provider value={{ ...nextOfKin, setNextOfKin }}>
        <VisitDetails.Provider value={{ ...visitData, setVisitDetails }}>
          <ReferralDetails.Provider
            value={{ ...referralData, setReferralDetails }}
          >
            <FinancialFormContext.Provider
              value={{ ...financialData, setFinancialData }}
            >
              <DataPayloadContext.Provider
                value={{ ...additnaldata, setadditnaldata }}
              >
                <QueueManagementContext.Provider
                  value={{
                    data: [...data],
                    setData: setQueueData,
                    allData,
                    setAllData,
                    onHoldData,
                    setOnHoldData,
                    previousData,
                    setPreviousData,
                    displayData,
                    displayPreviousData,
                    setDisplayData,
                    setDisplayPreviousData,
                    loader,
                    setloader,
                    previousQueue,
                    setpreviousQueue,
                    ActiveTab,
                    setActiveTab,
                    HeaderTabActive,
                    setHeaderTabActive,
                    previous,
                    setPrevious,
                    attend,
                    setAttend,
                    next,
                    setNext,
                    TabData,
                    setTabData, 
                    setSelectedQueue,
                    selectedQueue
                  }}
                >
                  <VisitFormContext.Provider
                    value={{ ...visitform, setvisitform }}
                  >
                    <RoleContext.Provider
                      value={{ ...role, setData }}
                    >
                      {props.children}
                    </RoleContext.Provider>
                  </VisitFormContext.Provider>
                </QueueManagementContext.Provider>
              </DataPayloadContext.Provider>
            </FinancialFormContext.Provider>
          </ReferralDetails.Provider>
        </VisitDetails.Provider>
      </NextOfKinContext.Provider>
    </PatientRegContext.Provider>
  );
};

export default AssembleReg;
